export default __webpack_public_path__ + "static/media/houseSearch.5d6571de.svg";